registerComponent("pages/wealth-planning", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Sem comportamento próprio — em 2020 também não tinha: o arquivo era um
 * `$(component)` comentado. A página é só LESS.
 *
 * ⚠️ A ROTA DESTA PÁGINA ESTÁ COMENTADA nos dois grupos de idioma
 * (`routes/site/web.php`), então o componente não tem call site nenhum e nada
 * aqui é exercitado pelo `browser-check`. Candidato ao protocolo de remoção da
 * Fase 9 — junto do `WealthPlanningController`, de `site/pages/wealth-planning.blade.php`
 * e de `config/pages/wealth-planning.php`. O NOME sobrevive fora deste conjunto:
 * `pages/wealth` tem um bloco com `data-url="wealth-management/wealth-planning/"`,
 * que é âncora dentro da página de wealth e não tem relação com esta.
 */

});
